function MainLayout({ children }) {
  return (
    <div className="min-h-screen bg-gradient-to-t from-[#DEF0FF] to-[#F7E6FF]">
      {children}
    </div>
  );
}

export default MainLayout;
